import { render, staticRenderFns } from "./GamificationProgress.vue?vue&type=template&id=f4ad92f4&scoped=true"
import script from "./GamificationProgress.vue?vue&type=script&lang=js"
export * from "./GamificationProgress.vue?vue&type=script&lang=js"
import style0 from "./GamificationProgress.vue?vue&type=style&index=0&id=f4ad92f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4ad92f4",
  null
  
)

export default component.exports